import {UIKIT_NAMESPACE} from '@hconnect/uikit/src/common'
import {ShellFooter} from '@hconnect/uikit/src/lib2'
import {FeatureFlagKey, useCommonFeatureFlag} from '@hproduce/feature-flags'
import {useTranslation} from 'react-i18next'
import {generatePath, useNavigate} from 'react-router'

import {routeToPrivacyPolicy, routeToTermsConditions} from '../../routes'

export const FooterContent = ({plantId}: {plantId?: string}) => {
  const {t} = useTranslation()

  const navigate = useNavigate()

  const isTermsAndConditionsEnabled = useCommonFeatureFlag(FeatureFlagKey.TermsAndConditions)

  const termsAndConditionsLinkProps = isTermsAndConditionsEnabled
    ? {
        footerLinks: [
          {
            label: t('legal.termsAndConditions', {ns: UIKIT_NAMESPACE}),
            link: generatePath(routeToTermsConditions, {plantId: plantId as string})
          },
          {
            label: t('legal.dataPrivacy', {ns: UIKIT_NAMESPACE}),
            link: generatePath(routeToPrivacyPolicy, {plantId: plantId as string})
          }
        ],
        navigate
      }
    : {}

  return <ShellFooter label={t('footer.poweredBy')} {...termsAndConditionsLinkProps} />
}
